import type { ForageKind } from "../api/forage";
import { KIND_RED_PNG } from "./forageSprites";

// How long the harvest-pop animation runs. The page schedules a
// cleanup at this delay (+ a small buffer) to remove the ghost
// element from the DOM after it's faded.
export const HARVEST_POP_MS = 280;

export interface ForageHarvestGhost {
  id: string;
  left: number;
  top: number;
  size: number;
  rotation: number;
  kind: ForageKind;
  bornAt: number;
}

interface Props {
  ghost: ForageHarvestGhost;
}

// Rendered at the click position while the actual plant slot is
// hidden via the page's `claimed` set. Plays the design's
// harvest-pop keyframe (scale up + drift up + fade) and is removed
// by the page after `HARVEST_POP_MS`.
export function ForageHarvestGhostImg({ ghost }: Props) {
  return (
    <img
      src={KIND_RED_PNG[ghost.kind]}
      alt=""
      draggable={false}
      style={{
        // The harvest-pop animation overrides the wrapper's
        // transform, so the per-plant rotation is lost during the
        // pop (matches the design). The strawberry's compensation
        // rotation is also overridden — the pop is brief enough
        // that a 45° flicker isn't distracting.
        position: "absolute",
        left: ghost.left,
        top: ghost.top,
        width: ghost.size,
        height: ghost.size,
        transform: `rotate(${ghost.rotation}deg)`,
        animation: `harvest-pop ${HARVEST_POP_MS}ms ease-out forwards`,
        pointerEvents: "none",
        imageRendering: "pixelated",
        zIndex: 250,
        userSelect: "none",
        WebkitUserSelect: "none",
      }}
    />
  );
}
